import { Card, CardContent } from '@napaicp/ui'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import type { HomeWorkspace, HomeWorkspaceKey } from '@/features/home/derive-home'

/**
 * "我的工作區" — Workspace *navigation*, not a Role Switcher: each card is
 * "go to the screen for this capability", never "become this role" or
 * "hide my other capabilities while I'm here". Only capabilities the caller
 * actually holds render at all (`useHomeOverview` already filtered this —
 * see `deriveWorkspaces`).
 */

const TITLE_KEY: Record<HomeWorkspaceKey, string> = {
  participate: 'workspaces.participate.title',
  manage: 'workspaces.manage.title',
  judge: 'workspaces.judge.title',
  platform: 'workspaces.platform.title',
}

const COUNT_KEY: Record<HomeWorkspaceKey, string> = {
  participate: 'workspaces.participate.count',
  manage: 'workspaces.manage.count',
  judge: 'workspaces.judge.count',
  platform: 'workspaces.platform.count',
}

const CTA_KEY: Record<HomeWorkspaceKey, string> = {
  participate: 'workspaces.participate.cta',
  manage: 'workspaces.manage.cta',
  judge: 'workspaces.judge.cta',
  platform: 'workspaces.platform.cta',
}

export function MyWorkspacesSection({ workspaces }: { workspaces: HomeWorkspace[] }) {
  const { t } = useTranslation('home')

  if (workspaces.length === 0) {
    return null
  }

  return (
    <section className="flex flex-col gap-3" aria-labelledby="my-workspaces-heading">
      <h2 id="my-workspaces-heading" className="text-xl font-semibold tracking-tight">
        {t('workspaces.title')}
      </h2>
      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4">
        {workspaces.map((workspace) => (
          <Link key={workspace.key} to={workspace.to} className="block text-inherit no-underline">
            <Card className="h-full transition-colors hover:border-primary/50">
              <CardContent className="flex flex-col gap-1 pt-6">
                <p className="text-sm font-medium text-muted-foreground">
                  {t(TITLE_KEY[workspace.key])}
                </p>
                <p className="text-lg font-semibold">
                  {t(COUNT_KEY[workspace.key], { count: workspace.count })}
                </p>
                <span className="text-sm font-medium text-primary">
                  {t(CTA_KEY[workspace.key])}
                </span>
              </CardContent>
            </Card>
          </Link>
        ))}
      </div>
    </section>
  )
}
